import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { LoginService } from 'app/services/login.service';
import { environment } from 'environments/environment';
interface Archivo {
    nombre: string;
    url: string | null;
}

interface CarpetaFormularios {
    titulo: string;
    archivos: Archivo[];
    expandido?: boolean;
}

@Component({
  selector: 'app-formularios-discapacidad',
  templateUrl: './formularios-discapacidad.component.html',
  styleUrls: [
    '../../../../app.newStyles.scss',
    './formularios-discapacidad.component.scss'
  ]
})
export class FormulariosDiscapacidadComponent implements OnInit {
    dataBreadcumbPages: Array<any> = [];
	dataBreadcumbTitle: any;
    env = environment;
    isLogged : boolean;
    rol: string;
    loadingPage = false;
    carpetas: CarpetaFormularios[] = [];
    path: string;
    
    constructor(
        private _loginService: LoginService, 
        private router: Router,
        private _location: Location,
    ) {
		this.dataBreadcumbPages = [{ page: 'Formularios de Discapacidad', route: ''}];
		this.dataBreadcumbTitle = [{ page: 'Discapacidad', route: '/discapacidad' }];
	}

    ngOnInit(): void {
        this._loginService.getAll().subscribe(resp => {
            this.isLogged = resp['isLogged'];
            if( !this.isLogged){
                this.router.navigate(['/login'])
            } else {
                this._loginService.getSessionData().subscribe(resp => {
                    this.rol = resp['rol'];
                     if (this.rol == 'PRVGRL' || this.rol == 'ASEPRV')
                        this.dataBreadcumbTitle = [{ page: 'Discapacidad', route: '/proveedores/discapacidad' }];
                     if (this.rol == 'ASEADM' || this.rol == 'ASEDIS')
                        this.dataBreadcumbTitle = [{ page: 'Discapacidad', route: '/index.php/discapacidad/page?view=index', externalUrl: true }];
                });
                this.cargarFormulariosMockeados();
            }
         });
      }

    cargarFormulariosMockeados(): void {
        // Mock de datos 
        this.carpetas = [
            {
                titulo: 'ANEXAS',
                expandido: false,
                archivos: [
                    {
                        nombre: 'HISTORIA CLINICA',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/ANEXAS/HISTORIA_CLINICA.pdf`
                    },
                    {
                        nombre: 'ORDEN MEDICA',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/ANEXAS/ORDEN_MEDICA.pdf`
                    },
                ]
            },
            {
                titulo: 'ASISTENCIALES',
                expandido: false,
                archivos: [
                    {
                        nombre: 'CAMBIO - BAJA DE PRESTADOR',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/ASISTENCIALES/CAMBIO_BAJA_DE_PRESTADOR.pdf`
                    },
                    {
                        nombre: 'DATOS SOCIO',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/ASISTENCIALES/DATOS_SOCIO.pdf`
                    },
                    {
                        nombre: 'DEPENDENCIA',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/ASISTENCIALES/DEPENDENCIA.pdf`
                    },
                    {
                        nombre: 'FORMULARIO FIM',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/ASISTENCIALES/FORMULARIO_FIM.pdf`
                    },
                    {
                        nombre: 'HISTORIA CLINICA',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/ASISTENCIALES/HISTORIA_CLINICA.pdf`
                    },
                    {
                        nombre: 'INFORME INICIAL - EVOLUTIVO',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/ASISTENCIALES/INFORME_INICIAL_EVOLUTIVO.pdf`
                    },
                    {
                        nombre: 'ORDEN MEDICA',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/ASISTENCIALES/ORDEN_MEDICA.pdf`
                    },
                    {
                        nombre: 'PRESUPUESTO',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/ASISTENCIALES/PRESUPUESTO.pdf`
                    }
                ]
            },
            {
                titulo: 'EDUCATIVO TERAPÉUTICO',
                expandido: false,
                archivos: [
                    {
                        nombre: 'CAMBIO - BAJA DE PRESTADOR',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/EDUCATIVO_TERAPEUTICO/CAMBIO_BAJA_DE_PRESTADOR.pdf`
                    },
                    {
                        nombre: 'DATOS SOCIO',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/EDUCATIVO_TERAPEUTICO/DATOS_SOCIO.pdf`
                    },
                    {
                        nombre: 'DEPENDENCIA',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/EDUCATIVO_TERAPEUTICO/DEPENDENCIA.pdf`
                    },
                    {
                        nombre: 'FORMULARIO FIM',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/EDUCATIVO_TERAPEUTICO/FORMULARIO_FIM.pdf`
                    },
                    {
                        nombre: 'HISTORIA CLINICA',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/EDUCATIVO_TERAPEUTICO/HISTORIA_CLINICA.pdf`
                    },
                    {
                        nombre: 'INFORME INICIAL - EVOLUTIVO',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/EDUCATIVO_TERAPEUTICO/INFORME_INICIAL_EVOLUTIVO.pdf`
                    },
                    {
                        nombre: 'ORDEN MEDICA',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/EDUCATIVO_TERAPEUTICO/ORDEN_MEDICA.pdf`
                    },
                    {
                        nombre: 'PRESUPUESTO',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/EDUCATIVO_TERAPEUTICO/PRESUPUESTO.pdf`
                    }
                ]
            },
            {
                titulo: 'ESCOLARIDAD',
                expandido: false,
                archivos: [
                    {
                        nombre: 'CAMBIO O BAJA DE PRESTADOR',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/ESCOLARIDAD/CAMBIO_O_BAJA_DE_PRESTADOR.pdf`
                    },
                    {
                        nombre: 'DATOS SOCIO - FAMILIARES',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/ESCOLARIDAD/DATOS_SOCIO_FAMILIARES.pdf`
                    },
                    {
                        nombre: 'HISTORIA CLINICA',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/ESCOLARIDAD/HISTORIA_CLINICA.pdf`
                    },
                    {
                        nombre: 'INFORME INICIAL - EVOLUTIVO',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/ESCOLARIDAD/INFORME_INICIAL_EVOLUTIVO.pdf`
                    },
                    {
                        nombre: 'ORDEN MEDICA',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/ESCOLARIDAD/ORDEN_MEDICA.pdf`
                    },
                    {
                        nombre: 'PRESUPUESTO',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/ESCOLARIDAD/PRESUPUESTO.pdf`
                    }
                ]
            },
            {
                titulo: 'INTEGRACION ESCOLAR',
                expandido: false,
                archivos: [
                    {
                        nombre: 'ACTA DE ACUERDO',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/INTEGRACION_ESCOLAR/ACTA_DE_ACUERDO.pdf`
                    },
                    {
                        nombre: 'CAMBIO - BAJA DE PRESTADOR',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/INTEGRACION_ESCOLAR/CAMBIO_BAJA_DE_PRESTADOR.pdf`
                    },
                    {
                        nombre: 'CONSTANCIA ALUMNO REGULAR',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/INTEGRACION_ESCOLAR/CONSTANCIA_ALUMNO_REGULAR.pdf`
                    },
                    {
                        nombre: 'DATOS SOCIO',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/INTEGRACION_ESCOLAR/DATOS_SOCIO.pdf`
                    },
                    {
                        nombre: 'HISTORIA CLINICA',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/INTEGRACION_ESCOLAR/HISTORIA_CLINICA.pdf`
                    },
                    {
                        nombre: 'INFORME INICIAL - EVOLUTIVO',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/INTEGRACION_ESCOLAR/INFORME_INICIAL_EVOLUTIVO.pdf`
                    },
                    {
                        nombre: 'ORDEN MEDICA',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/INTEGRACION_ESCOLAR/ORDEN_MEDICA.pdf`
                    },
                    {
                        nombre: 'PPI',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/INTEGRACION_ESCOLAR/PPI.pdf`
                    },
                    {
                        nombre: 'PRESUPUESTO',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/INTEGRACION_ESCOLAR/PRESUPUESTO.pdf`
                    }
                ]
            },
            {
                titulo: 'REHABILITACION',
                expandido: false,
                archivos: [
                    {
                        nombre: 'CAMBIO - BAJA DE PRESTADOR',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/REHABILITACION/CAMBIO_BAJA_DE_PRESTADOR.pdf`
                    },
                    {
                        nombre: 'CONSTANCIA ALUMNO REGULAR',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/REHABILITACION/CONSTANCIA_DE_ALUMNO_REGULAR.pdf`
                    },
                    {
                        nombre: 'DATOS SOCIO',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/REHABILITACION/DATOS_SOCIO.pdf`
                    },
                    {
                        nombre: 'HISTORIA CLINICA',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/REHABILITACION/HISTORIA_CLINICA.pdf`
                    },
                    {
                        nombre: 'INFORME INICIAL - EVOLUTIVO',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/REHABILITACION/INFORME_INICIAL_EVOLUTIVO.pdf`
                    },
                    {
                        nombre: 'NOTA BENEFICIARIOS NO ESCOLARIZADOS',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/REHABILITACION/NOTA_BENEFICIARIOS_NO_ESCOLARIZADOS.pdf`
                    },
                    {
                        nombre: 'ORDEN MEDICA',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/REHABILITACION/ORDEN_MEDICA.pdf`
                    },
                    {
                        nombre: 'PLANILLA DE ESTIMULACION TEMPRANA',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/REHABILITACION/PLANILLA_DE_ESTIMULACION_TEMPRANA.pdf`
                    },
                    {
                        nombre: 'PRESUPUESTO',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/REHABILITACION/PRESUPUESTO.pdf`
                    }
                ]
            },
            {
                titulo: 'TRANSPORTE',
                expandido: false,
                archivos: [
                    {
                        nombre: 'CAMBIO - BAJA DE PRESTADOR',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/TRANSPORTE/CAMBIO_BAJA_DE_PRESTADOR.pdf`
                    },
                    {
                        nombre: 'CONSTANCIA ALUMNO REGULAR',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/TRANSPORTE/CONSTANCIA_DE_ALUMNO_REGULAR.pdf`
                    },
                    {
                        nombre: 'DATOS SOCIO',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/TRANSPORTE/DATOS_SOCIO.pdf`
                    },
                    {
                        nombre: 'DEPENDENCIA',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/TRANSPORTE/DEPENDENCIA.pdf`
                    },
                    {
                        nombre: 'DJ DE TRANSPORTE',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/TRANSPORTE/DJ_DE_TRANSPORTE.pdf`
                    },
                    {
                        nombre: 'FORMULARIO FIM',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/TRANSPORTE/FORMULARIO_FIM.pdf`
                    },
                    {
                        nombre: 'HISTORIA CLINICA',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/TRANSPORTE/HISTORIA_CLINICA.pdf`
                    },
                    {
                        nombre: 'JUSTIFICACION DE KM',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/TRANSPORTE/JUSTIFICACION_KM.pdf`
                    },
                    {
                        nombre: 'NOTA BENEFICIARIOS NO ESCOLARIZADOS',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/TRANSPORTE/NOTA_BENEFICIARIOS_NO_ESCOLARIZADOS.pdf`
                    },
                    {
                        nombre: 'ORDEN MEDICO POR TRANSPORTE',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/TRANSPORTE/ORDEN_MEDICO_POR_TRANSPORTE.pdf`
                    },
                    {
                        nombre: 'PRESUPUESTO DE TRANSPORTE',
                        url: `${environment.urlDownloads}formularios/discapacidad/2026/TRANSPORTE/PRESUPUESTO_DE_TRANSPORTE.pdf`
                    }
                ]
            }
        ];
    }

    toggleCarpeta(index: number): void {
        this.carpetas[index].expandido = !this.carpetas[index].expandido;
    }

    onBackButton() {
        this._location.back();
    }

    linkPanel() {
        window.location.href = environment.urlWebSitePhp + 'site/inicio'
    }

    linkDiscapacidad() {
         if(this.rol == 'ASEADM' || this.rol == 'ASEDIS')
            window.location.href = environment.urlWebSitePhp + 'discapacidad/page?view=index';
        if (this.rol == 'PRVGRL' || this.rol == 'ASEPRV')
            this.router.navigate(['proveedores/discapacidad']);
        else
            this.router.navigate(['discapacidad']);
    }
}
